<mat-table #table
  [dataSource]="dataSource" matSort>

  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        [disabled]="dataSource.filteredData && dataSource.filteredData.length === 0"
        aria-label="Select All">

      </mat-checkbox>
    </mat-header-cell>

    <mat-cell mat-cell
      *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
        (change)="$event ? selectRow(row) : null"
        [checked]="selection.isSelected(row)"
        aria-label="Select Row">
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lithocode">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Document ID</mat-header-cell>
    <mat-cell *matCellDef="let element">
      @if (element.scoringStatus !== 'rejected') {
        <a [routerLink]="['/biographic', element.lithocode, 'edit']"
          >
          {{element.lithocode}}
        </a>
      }
      @else if (element.scoringStatus === 'rejected') {
        <div
          >
          {{element.lithocode}}
        </div>
      }

    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="form">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Form / Level</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.form}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stateStudentId">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Student ID Number</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.stateStudentId}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef mat-sort-header> First Name</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.firstName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.lastName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="birthDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Date of Birth</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.birthDate}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="gender">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Gender</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.gender}}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

